// Narrow-screen viewport shim for handheld scanners.
//
// Android's "Display size" setting rescales screen density, which the browser
// reports as a different CSS viewport. On the Honeywell EDA61K (4" 800x480)
// the "Small" size yields ~376 CSS px of width — the geometry Quartz's mobile
// layouts were tuned on — while "Default" yields 320, where the pinned item
// column and numeric cells no longer fit.
//
// When the SCREEN (not the window) is narrower than any supported phone, pin
// the layout viewport to the Small-size width and let the browser scale the
// page to fit. The result is pixel-for-pixel the Small rendering, whatever
// the OS setting says. Phones (>= 360 CSS px), tablets and desktops never
// qualify — screen.width, not innerWidth, so a narrow desktop window is
// unaffected too.
const NARROW_SCREEN_MAX = 340;   // widest screen that gets the shim (CSS px)
const LAYOUT_WIDTH = 376;        // EDA61K "Small" display-size width (CSS px)

export function applyNarrowViewportShim() {
  const meta = document.querySelector('meta[name="viewport"]') as HTMLMetaElement;
  if (!meta || !window.screen) {
    return;
  }
  const original = meta.getAttribute('content');

  const apply = () => {
    // screen.width is the device screen in CSS px at the current density and
    // is not affected by the layout width we set, so re-evaluation is stable.
    const screenWidth = window.screen.width;
    if (screenWidth > 0 && screenWidth <= NARROW_SCREEN_MAX) {
      const scale = (screenWidth / LAYOUT_WIDTH).toFixed(4);
      const content = `width=${LAYOUT_WIDTH}, initial-scale=${scale}, minimum-scale=${scale}, maximum-scale=${scale}, user-scalable=no`;
      if (meta.getAttribute('content') !== content) {
        meta.setAttribute('content', content);
      }
    } else if (meta.getAttribute('content') !== original) {
      meta.setAttribute('content', original);
    }
  };

  apply();
  window.addEventListener('orientationchange', () => setTimeout(apply, 100));
}
